import {
    HIDE_CART_BUTTON,
    SET_ONE_COLUMN_LAYOUT, SET_PREVIOUS_HISTORY,
    SHOW_CART_BUTTON,
    SHOW_PAGE,
    UNSET_ONE_COLUMN_LAYOUT
} from '../actions/common.actions';

const initialState = {
    currentPage: 'restaurant',
    oneColumnPage: false,
    isShowCartButton: true,
    prevHistory: null
};

const CommonReducer = function (state = initialState, action) {
    switch (action.type) {
        case SHOW_PAGE:
            return {
                ...state,
                currentPage: action.page
            };
        case SET_ONE_COLUMN_LAYOUT:
            return {
                ...state,
                oneColumnPage: true
            };
        case UNSET_ONE_COLUMN_LAYOUT:
            return {
                ...state,
                oneColumnPage: false
            };
        case SHOW_CART_BUTTON:
            return {
                ...state,
                isShowCartButton: true
            };
        case HIDE_CART_BUTTON:
            return {
                ...state,
                isShowCartButton: false
            };
        case SET_PREVIOUS_HISTORY:
            return {
                ...state,
                prevHistory: action.payload
            };
        default:
            return state;
    }
};

export default CommonReducer;